import { DocumentReference } from '.';

export class User {
    id: string;
    church: DocumentReference;
    email: string;
    firstName: string;
    isActive: boolean;
    isDeleted: boolean;
    role: string;
    lastName: string;
    mobile: string;
    title: string;
    wwcCardNumber: string;
    wwcCardExpiry: Date;
}
